import { render, staticRenderFns } from "./batchDetentionDialog.vue?vue&type=template&id=1fbe1cf1&scoped=true"
import script from "./batchDetentionDialog.vue?vue&type=script&lang=js"
export * from "./batchDetentionDialog.vue?vue&type=script&lang=js"
import style0 from "./batchDetentionDialog.vue?vue&type=style&index=0&id=1fbe1cf1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe1cf1",
  null
  
)

export default component.exports